import dataProvider from "../../../../../providers/data-provider";
import DashboardFilter from "./dashboard-filter";

const fetchInstitutions = async (search) => {
    const response = await dataProvider.getList(
        'institutions',
        {
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'name', order: 'ASC' },
            filter: { name: search }
        })
    return response.data;
}

export const InstitutionFilter = ({ profile, filters, setFilters }) => {

    return <DashboardFilter
        filterKey="institutionId"
        label="Instituição"
        value={filters.institution?.id}
        setFilters={setFilters}
        fetchOptions={
            fetchInstitutions
        }
    />
}